import React, { useCallback } from "react";
import { isEmpty, cls } from "app/utils";
import default_profile_img from "app/images/fallback/profiles/square_default.png";

type PropsDef = {
  className?: string;
  srcName?: string;
  altName?: string;
  sizeWidth?: number;
  sizeHeight?: number;
  kind?: string;
  userName?: string;
};

/**
 * Corrects the URL for the default user avatar when the user
 * has not set an avatar yet.
 *
 * @method UserAvatar
 */
const UserAvatar: React.FC<PropsDef> = React.memo((props) => {
  const kind = props.kind != null ? props.kind : "";
  let srcName = props.srcName;
  const userName = props.userName;

  const getNameInitials = useCallback(() => {
    if (props.userName) {
      const separateNames = props.userName.split(" ");
      const prepareInitials =
        (separateNames[0][0] || "") +
        (separateNames[separateNames.length - 1][0] || "");
      return prepareInitials.toUpperCase();
    }
    return null;
  }, [props.userName]);

  if (!userName?.trim()) {
    return (
      <img
        src={default_profile_img}
        alt={props.altName}
        width={props.sizeWidth}
        height={props.sizeHeight}
        className={cls(props.className, kind)}
      />
    );
  }

  if (srcName && srcName.includes("default")) {
    return (
      <div className={cls("user-avatar avatar", props.className)}>
        {getNameInitials()}
      </div>
    );
  }

  if (
    isEmpty(srcName) ||
    srcName.indexOf("/assets/fallback/profiles/square_default") !== -1
  ) {
    srcName = default_profile_img;
  }

  return (
    <img
      src={srcName}
      alt={props.altName}
      width={props.sizeWidth}
      height={props.sizeHeight}
      className={cls(props.className, kind)}
    />
  );
});

export default UserAvatar;
